import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';

@Component({
  selector: 'app-duration',
  standalone: true,
  imports: [
    TranslateModule,
    DurationPipe,
  ],
  templateUrl: './duration.component.html',
  styleUrls: ['./duration.component.scss'],
})
export class DurationComponent {
  public duration = input<number>();
}
